import APIService from "../config/api-service";
import toast from 'react-hot-toast';
import { MESSAGE } from "../config/mesage";
import { encodeEmail, isValidEmailStructure } from '../config/emailEncoder'

const AuthService = {

  login: async (accessToken) => {
    try {
      const res = await APIService.login(accessToken);
      if (res?.status == 200 && res?.success) {
        AuthService.setToken(res.data.token);
        const user = await AuthService.getAuthData();
        return user;
      } else {
        toast(MESSAGE.ERROR.ACCOUNT_DOES_NOT_EXIST, { duration: 6000 });
        return null;
      }
    } catch (error) {
      toast(MESSAGE.ERROR.ACCOUNT_DOES_NOT_EXIST, { duration: 6000 });
      return null;
    }
  },

  getAuthData: async () => {
    try {
      const res = await APIService.authData();
      if (res?.status == 200 && res?.success) {
        const user = res?.data;
        return user;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },

  setToken: (token) => {
    localStorage.setItem('token', token);
  },

  getToken: () => {
    const token = localStorage.getItem('token');
    return token ? token : null
  },

  setMSToken: (token) => {
    localStorage.setItem('accessToken', token);
  },

  getMSToken: () => {
    const accessToken = localStorage.getItem('accessToken');
    return accessToken ? accessToken : null;
  },

  setGaId: (email) => {
    if (email) {
      const isValid = isValidEmailStructure(email);
      if (isValid) {
        const gaId = encodeEmail(email);
        localStorage.setItem('gaId', JSON.stringify(gaId));
      } else {
        localStorage.removeItem('gaId');
      }
    }
  },

  getGaId: () => {
    const value = localStorage.getItem('gaId');
    return value ? String(JSON.parse(value)) : null;
  }
};


export default AuthService;